<app-basic-page [pageTitle]="'Leads - Reports'">
  <div class="vertical grid-content">
    <nz-tabset>
      <nz-tab nzTitle="My Report">
        <div class="tab-content horizontal wrap">
          @for (item of myWeeklyLeads(); track $index) {
            <app-leads-time-range-card [data]="item"></app-leads-time-range-card>
          }
        </div>
      </nz-tab>
      <nz-tab nzTitle="Team Report">
        <div class="tab-content horizontal wrap">
          @for (item of weeklyLeads(); track $index) {
            <app-leads-time-range-card [data]="item"></app-leads-time-range-card>
          }
        </div>
      </nz-tab>
    </nz-tabset>
  </div>
</app-basic-page>
